import Vue from 'vue'
import App from './App'
import router from './router'
import Axios from 'axios'
import Vuelidate from 'vuelidate'
import VueMask from 'vue-the-mask'
import store from './globals/store'
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
import VueTour from 'vue-tour'

import GlobalVariables from './globals/variables'
import GlobalMethods from './globals/methods'
import GlobalComponents from './globals/components'
import GlobalFilters from './globals/filters'
import DatatableFactory from 'vuejs-datatable/index.js'
import VueHtmlToPaper from 'vue-html-to-paper'
import VScrollLock from 'v-scroll-lock'
import GlobalDirectives from './globals/directives'

const printOptions = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=no',
    'scrollbars=no'
  ],
  styles: [
    '/static/style/print.css'
  ]
}

// Vue Developer Tools desabilitado em produção
if (process.env.NODE_ENV !== 'production') {
  Vue.config.productionTip = true
  Vue.config.debug = true
  Vue.config.devtools = true
}

DatatableFactory.useDefaultType(false)
  .registerTableType('datatable', function (tableType) {
    tableType.mergeSettings({
      table: {
        class: 'table table-hover ',
        sorting: {
          classes: {
            canSort: ['sort'],
            sortNone: ['sortable', 'icon icon-resize-vert'],
            sortAsc: ['sortable', 'icon icon-downward'],
            sortDesc: ['sortable', 'icon icon-upward']
          }
        }
      }
      // pager: {
      //   classes: {
      //     pager: 'pagination text-center',
      //     selected: 'current'
      //   }
      // }
    })
  })
Vue.use(VueMask)
Vue.use(Vuelidate)
Vue.use(GlobalVariables)
Vue.use(GlobalMethods)
Vue.use(GlobalComponents)
Vue.use(GlobalFilters)
Vue.use(GlobalDirectives)
Vue.use(DatatableFactory)
Vue.use(VScrollLock)
Vue.use(VueMoment, { moment })
Vue.use(VueHtmlToPaper, printOptions)
Vue.use(VueTour)

Axios.defaults.baseURL = process.env.ROOT_API
window.axios = Axios
Vue.prototype.API_URL = process.env.ROOT_API
Vue.prototype.$http = window.axios
Vue.prototype.$filters = Vue.options.filters

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
